/* WHAT THE PERSON HAS OPEN, for the floating Catchy (Jay, System Project task 30/10: "When Catchy is opened from a page, pass
   the page context with each question … 'This document' or 'this sample' should then just work" — he had DOC-001 v2.0 open
   and asked "compare with the previous version", and Catchy asked which document).
   A screen that opens an item says so with usePageItem({ kind, id, version?, label?, screen? }); the item disappears when the
   screen (or its dialog) closes. Items stack: a round opened over the Sample Tracker covers it, and closing the round brings
   the page back. AskBubble reads the top one and sends it with the question. Only ids travel: what Catchy may read about the
   item is still decided by its tools, with the person's own rights. */
import { useEffect, useSyncExternalStore } from 'react';

let stack = [];
let seq = 0;
const subs = new Set();
const emit = () => subs.forEach((fn) => fn());
const subscribe = (fn) => { subs.add(fn); return () => subs.delete(fn); };
const snapshot = () => (stack.length ? stack[stack.length - 1] : null);

export const usePageItemNow = () => useSyncExternalStore(subscribe, snapshot);

export function usePageItem(item) {
  const key = item && item.id ? JSON.stringify(item) : '';
  useEffect(() => {
    if (!key) return undefined;
    const mine = { ...JSON.parse(key), n: ++seq };
    stack = [...stack, mine]; emit();
    return () => { stack = stack.filter((x) => x.n !== mine.n); emit(); };
  }, [key]);
}
